var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgConnectRecursive16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_68725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 3.5H6.91386L8.70686 1.70705L7.99981 1L4.99981 4L7.99981 7L8.70686 6.29295L6.91386 4.5H13.9998V10H5.94926C5.85034 9.52012 5.61298 9.07974 5.26652 8.73328C4.92007 8.38682 4.47968 8.14947 3.99981 8.05055V1H2.99981V8.05055C2.43525 8.16584 1.92785 8.4726 1.56345 8.91894C1.19904 9.36528 1 9.9238 1 10.5C1 11.0762 1.19904 11.6347 1.56345 12.0811C1.92785 12.5274 2.43525 12.8342 2.99981 12.9494V15H3.99981V12.9494C4.47968 12.8505 4.92007 12.6132 5.26652 12.2667C5.61298 11.9203 5.85034 11.4799 5.94926 11H13.9998C14.2649 10.9997 14.5191 10.8942 14.7066 10.7068C14.894 10.5193 14.9995 10.2651 14.9998 10V4.5C14.9995 4.23488 14.894 3.9807 14.7066 3.79323C14.5191 3.60576 14.2649 3.5003 13.9998 3.5ZM3.49981 12C3.20313 12 2.91312 11.912 2.66645 11.7472C2.41978 11.5824 2.22752 11.3481 2.11399 11.074C2.00045 10.7999 1.97075 10.4983 2.02863 10.2074C2.08651 9.91639 2.22937 9.64912 2.43915 9.43934C2.64892 9.22956 2.9162 9.0867 3.20717 9.02882C3.49814 8.97094 3.79974 9.00065 4.07383 9.11418C4.34792 9.22771 4.58219 9.41997 4.74701 9.66665C4.91183 9.91332 4.99981 10.2033 4.99981 10.5C4.99937 10.8977 4.84119 11.279 4.55998 11.5602C4.27877 11.8414 3.8975 11.9996 3.49981 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_68725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgConnectRecursive16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connect-recursive-16.886d6c625d473a55ffeed03ef05a38dd.svg";